/* Body v2: todo "Finalizar compra" do tema (carrinho lateral e página /cart) passa pela Yampi.
   O carrinho é enviado para a API da Yampi (a mesma do YampiSnippet) e o cliente vai direto ao
   checkout dela. Se a Yampi falhar ou demorar mais de 6 s:
   - no carrinho lateral, o cliente vai para /cart;
   - na própria /cart, aparece um aviso com saída pelo WhatsApp (sem recarregar em loop).
   Na /cart, o botão que o YampiSnippet injeta fica escondido (body.css): sobra um único botão,
   o do tema, tratado aqui. O carregador de tela cheia do YampiSnippet só some com resposta 200;
   se ele ficar mais de 6 s na tela, é escondido e o aviso aparece.
   Adaptado de assets/vpr-global.js do tema da VPR. */
(() => {
  if (window.__bodyYampi) return;
  window.__bodyYampi = true;

  const LIMITE_MS = 6000;
  const naPaginaCarrinho = () => /^\/cart\/?$/.test(window.location.pathname);

  function mostrarAviso() {
    if (document.querySelector('.body-yampi-aviso')) return;
    const aviso = document.createElement('p');
    aviso.className = 'body-yampi-aviso';
    aviso.setAttribute('role', 'alert');
    aviso.innerHTML = 'Não conseguimos abrir o pagamento agora. Tente de novo em instantes ou finalize pelo WhatsApp: <a href="https://wa.me/5575981896216" target="_blank" rel="noopener">(75) 98189-6216</a>';
    const alvo = document.querySelector('main #checkout, main [name="checkout"]');
    if (alvo && alvo.parentElement) alvo.parentElement.insertBefore(aviso, alvo);
    else (document.querySelector('main') || document.body).prepend(aviso);
  }

  function esconderCarregadorYampi() {
    const l = document.querySelector('.yampi-loader');
    if (l) l.style.display = 'none';
  }

  function falhou() {
    esconderCarregadorYampi();
    if (naPaginaCarrinho()) mostrarAviso();
    else window.location.href = '/cart';
  }

  // Botão de finalizar do tema (não o injetado pela Yampi, que fica escondido na /cart).
  const SELETOR = 'cart-drawer-component [name="checkout"], cart-drawer-component #checkout, #checkout:not(.ymp_check_mainBtn), [name="checkout"]:not(.ymp_check_mainBtn)';

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(SELETOR);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    let terminou = false;
    const limite = setTimeout(() => { if (!terminou) { terminou = true; btn.removeAttribute('aria-busy'); falhou(); } }, LIMITE_MS);
    try {
      const cart = await (await fetch('/cart.js')).json();
      const res = await fetch('https://api.dooki.com.br/v2/public/shopify/cart', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ shop: window.location.host, shopify_internal_domain: window.Shopify && window.Shopify.shop, cart_payload: cart }),
      });
      const data = res.ok ? await res.json() : null;
      if (terminou) return;
      terminou = true;
      clearTimeout(limite);
      if (data && data.active && data.checkout_direct_url) {
        const url = typeof window.ymp_getUrlWithUtms === 'function' ? window.ymp_getUrlWithUtms(data.checkout_direct_url) : data.checkout_direct_url;
        window.location.href = url;
        return;
      }
      btn.removeAttribute('aria-busy');
      falhou();
    } catch (err) {
      if (terminou) return;
      terminou = true;
      clearTimeout(limite);
      btn.removeAttribute('aria-busy');
      falhou();
    }
  }, true);

  // Carregador de tela cheia do YampiSnippet preso (Yampi fora): esconde e avisa.
  if (naPaginaCarrinho()) {
    setTimeout(() => {
      const l = document.querySelector('.yampi-loader');
      if (l && getComputedStyle(l).display !== 'none') {
        esconderCarregadorYampi();
        mostrarAviso();
      }
    }, LIMITE_MS);
  }
})();
